// extracted by mini-css-extract-plugin
module.exports = {"star":"starrating_star__F36CK","count":"starrating_count__RxRNx","rating":"starrating_rating__nmNlc","fadein":"starrating_fadein___l__W","loading":"starrating_loading__2Gydi"};